export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_5hundred.png",
      alt: "Nome da extensão",
    },
    title: "OPERE NO AUTOMATICO COM A 5HUNDRED BOT",
    text: [
      "Com operações totalmente automatizadas, você não precisa ficar o tempo todo na frente do computador. \nNossa automação prioriza o equilíbrio entre risco e retorno, oferecendo praticidade, consistência e gestão responsável no mercado financeiro.",
    ],
    // testimonial: {
    //   author: {
    //     picture: "https://i.pravatar.cc/150?img=70",
    //   },
    // },
  },
  features: {
    title: "Por que utilizar os robôs da 5Hundred Bot?",
    subtitle: "Veja quais as principais vantagens dos robôs da 5Hundred Bot.",
    data: [
      {
        title: "Automação completa",
        description:
          "O bot executa as operações automaticamente, eliminando a necessidade de acompanhamento constante do mercado ou abertura de plataformas.",
      },
      {
        title: "Disciplina operaciona",
        description:
          "As entradas e saídas seguem regras pré-definidas, evitando decisões emocionais e mantendo consistência na execução.",
      },
      {
        title: "Equilíbrio entre risco e retorno",
        description:
          "A estratégia busca preservar capital e otimizar resultados por meio de gestão de risco estruturada.",
      },
      {
        title: "Praticidade e economia de tempo",
        description:
          "Permite ao cliente participar do mercado financeiro mesmo com rotina cheia, sem precisar ficar em frente ao computador.",
      },
      {
        title: "Estratégia testada",
        description:
          "O método utilizado foi validado por backtests históricos, trazendo maior previsibilidade e transparência ao processo.",
      },
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a 5Hundred Bot",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A 5Hundred Bot",
    col1: [
      " 5 Hundred está no mercado financeiro levando automação e tecnologia para investidores que buscam praticidade. \nNossa proposta é mostrar que é possível operar na bolsa de valores por meio de operações automatizadas, sem a necessidade de acompanhar gráficos ou plataformas em tempo integral. ",
      "Na 5 Hundred, acreditamos que resultados consistentes no mercado financeiro não vêm de tentativas isoladas ou decisões emocionais, mas da confiança em um processo bem estruturado. Nosso trabalho é baseado em método, disciplina e automação, permitindo que o cliente participe do mercado de forma prática, sem a necessidade de acompanhamento constante ou tomada de decisões impulsivas. ",
    ],
    col2: [
      "Aqui, o foco não está em ganhos imediatos, mas na constância ao longo do tempo. O robô executa as operações de acordo com regras definidas, enquanto o cliente confia no método e respeita o processo. Menos emoção, mais método. \n\nQuando você escolhe a 5 Hundred, não está apenas utilizando uma automação, mas fazendo parte de uma filosofia onde disciplina gera consistência e o tempo se torna um aliado. Confiança no processo é o que nos move. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão 5Hundred Bot",
  },
  strategies: {
    title: "ESTRATEGIAS 5HUNDREDBOOT",
    heading: "AS MELHORES ESTRATEGIAS AUTOMATIZADAS, TESTADAS E ACOMPANHADAS HA MAIS DE 5 ANOS. ",
  },
};
